<template>
  <el-dialog
    lock-scroll
    :title="title"
    class="shipListDialog"
    top="150px"
    :visible.sync="dialogShow"
    width="1100px"
    :before-close="handleClose"
  >
    <div class="shipList">
      <div class="searchList">
        <el-form
          :inline="true"
          align="right"
          :model="formData"
          class="demo-form-inline"
        >
          <el-form-item label="船舶名称：">
            <el-input
              v-model="formData.shipName"
              disabled="true"
              size="mini"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="月份：" class="widthInherit">
            <el-date-picker
              v-model="formData.month"
              type="month"
              size="mini"
              value-format="yyyy-MM"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="flex widthInherit">
            <el-button type="primary" size="mini" @click="search"
              >查询</el-button
            >
            <el-button type="primary" size="mini" class="addBtn" @click="submit"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="shipList"
        border
        align="left"
        header-row-class-name="other-header"
        row-class-name="other-row"
        ref="multipleTable"
        :row-key="
          (row) => {
            return row.shipId;
          }
        "
        max-height="456px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="shipName" label="船舶名称"> </el-table-column>
        <el-table-column prop="month" label="月份"> </el-table-column>
        <el-table-column prop="instruction" label="标题"> </el-table-column>
        <el-table-column prop="outsourcingRewardCount" label="金额">
        </el-table-column>
      </el-table>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="cancelBtn">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { showPrepareBindingList } from "@/apis/index";
export default {
  data() {
    return {
      title: "添加节能奖惩",
      dialogShow: false,
      shipList: [],
      chosedShip: [],
      oldChosed: [],
      formData: {
        shipName: "",
      },
      modType: "",
      paramsInfo: {},
    };
  },
  methods: {
    search() {
      this.getShip();
    },
    showToggle(list, row) {
      if (row.type == "1") {
        this.title = "添加节能奖惩";
      } else if (row.type == "2") {
        this.title = "添加其他奖励";
      } else if (row.type == "3") {
        this.title = "添加优秀船员";
      }else if (row.type == "4") {
        this.title = "添加船舶考核";
      } else if (row.type == "5") {
        this.title = "添加客餐费";
      }
      this.shipList = [];
      this.paramsInfo = row;
      // this.$set(this.formData,"month",row.month)
      this.$set(this.formData, "shipName", row.shipName);
      // this.formData.month = row.month
      this.dialogShow = true;
      this.chosedShip = list;
      this.oldChosed = JSON.parse(JSON.stringify(list));
      this.getShip();
    },
    async getShip() {
      const data = {
        shipName: this.formData.shipName,
        month: this.formData.month,
        rewardType: this.paramsInfo.type,
        outsourcingShipId: this.paramsInfo.id,
        shipId: this.paramsInfo.shipId,
      };
      const res = await showPrepareBindingList(data);
      res.data.forEach((val) => {
        this.oldChosed.forEach((el) => {
          if (val.id == el.id) {
            val.crewList = el.crewList;
          }
        });
      });

      this.shipList = res.data;
      this.$nextTick(() => {
        this.shipList.forEach((el) => {
          this.oldChosed.forEach((val) => {
            if (el.id == val.id) {
              this.$refs.multipleTable.toggleRowSelection(el, true);
            }
          });
        });
      });
      if (!this.chosedShip.length) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.chosedShip = val.filter((val) => {
        return typeof val != "string";
      });
    },
    submit() {
      // if (!this.chosedShip.length) {
      //   this.$message.error("请选择要添加的项！");
      //   return;
      // }
      this.$emit("choseShip", this.chosedShip);
      this.dialogShow = false;
      this.chosedShip = [];
    },
    handleClose() {
      this.dialogShow = false;
      this.chosedShip = [];
      this.oldChosed = [];
      this.formData = {
        shipName: "",
      };
    },
  },
};
</script>
<style lang="scss"></style>
